<script>
	import { getContext, onDestroy } from 'svelte'
	import { modalLogin, storeSiteAdmin } from '../library/scripts/Store.svelte'
	import { styles } from '../library/scripts/styles.js'
	import { setCookie } from '../library/scripts/cookie.js'
	import { validate } from '../library/scripts/validate.js'
	import { admin } from '../library/scripts/PhpHandler.svelte'
	import SelectCountry from '../library/selectors/SelectCountry.svelte'

	let username
	let pwd

	let errorPwd = false
	let errorUsername = false
	let errorCountryCode = false

	let errorMessage

	const globals = getContext('globals')

	const adminInputBg = globals.adminInputBg
	const inputWidth = '90%'
	const adminInputBorder = globals.adminInputBorder
	const adminInputFocus = globals.adminInputFocus
	const adminColorMain = globals.adminColorMain
	const fsS = globals.fsS
	const icon = globals.icon
	const colorError = globals.colorError
	const adminOptionBg = globals.adminOptionBg
	const selectHover = globals.selectHover

	//timeouts
	let toError

	// to add to phone number toprevent that user with same number but different country
	// logs to same account
	let countryCode = false

	const show_password = (id) => {
		const s = document.querySelector(id)
		if (s == null) return
		s.type = s.type === 'password' ? 'text' : 'password'
	}

	const send_login = async () => {
		if (!validate('input', username)) {
			errorUsername = true
			errorMessage = 'enter username '
			toError = setTimeout(() => {
				errorUsername = false
				errorMessage = null
			}, 2000)
			return
		}

		if (!validate('input', pwd)) {
			errorPwd = true
			errorMessage = 'enter password '
			toError = setTimeout(() => {
				errorPwd = false
				errorMessage = null
			}, 2000)
			return
		}

		if (!countryCode) {
			errorCountryCode = true
			errorMessage = 'select country '
			toError = setTimeout(() => {
				errorCountryCode = false
				errorMessage = null
			}, 2000)
			return
		}

		const response = await admin({ cmd: 'login', username: username, pwd: pwd, code: countryCode })

		if (response[0] === true && response[1] === true) {
			storeSiteAdmin.set(true)
			setCookie('id', response[2], 1)
			modalLogin.set(false)
			// document.location = '/#/builder'
			return
		}

		if (response[0] === false) {
			errorMessage = 'user does not exist'
			errorUsername = true
			toError = setTimeout(() => {
				errorUsername = false
			}, 2000)
		}

		if (response[1] === false) {
			errorMessage = 'wrong password'
			errorPwd = true
			toError = setTimeout(() => {
				errorPwd = false
			}, 2000)
		}
	}

	const variable_set_value = async (event) => {
		countryCode = event.detail.code
	}
	const keyDownLogin = (e) => {
		if (e.keyCode === 13) send_login()
	}

	onDestroy(() => {
		clearTimeout(toError)
	})
</script>

<svelte:window on:keydown={keyDownLogin} />
<main use:styles={{ adminInputBg }}>
	{#if !errorCountryCode}
		<SelectCountry
			on:select={variable_set_value}
			value="select country"
			cmd="country"
			inputBorder={adminInputBorder}
			inputBg={adminInputBg}
			optionBg={adminOptionBg}
			{selectHover}
		/>
	{:else}
		<span class="error" use:styles={{ colorError, fsS }}>{errorMessage}</span>
	{/if}

	<div
		class="inputContainer"
		use:styles={{ adminInputBg, adminInputBorder, inputWidth, adminInputFocus, adminColorMain, fsS }}
	>
		{#if !errorUsername}
			<input
				use:styles={{ adminColorMain, fsS }}
				bind:value={username}
				type="text"
				id="logname"
				placeholder="username"
			/>
		{:else}
			<span class="error" use:styles={{ colorError, fsS }}>{errorMessage}</span>
		{/if}
	</div>
	<div
		class="inputContainer"
		use:styles={{ adminInputBg, adminInputBorder, inputWidth, adminInputFocus, adminColorMain, fsS }}
	>
		{#if !errorPwd}
			<input use:styles={{ adminColorMain, fsS }} bind:value={pwd} type="password" id="logPwd" placeholder="password" />
		{:else}
			<span class="error" use:styles={{ colorError, fsS }}>{errorMessage}</span>
		{/if}
		<div
			class="eye"
			use:styles={{ icon }}
			on:click={() => show_password('#pwdLog')}
			on:keydown={() => show_password('#pwdLog')}
		/>
	</div>
	<div class="buttonContainer">
		<button on:click={send_login} use:styles={{ fsS, adminInputBorder, adminColorMain, adminInputBg }}>login</button>
	</div>
</main>

<style>
	main {
		display: flex;
		width: 100%;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		padding: 20px;
	}

	button {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: var(--fsS);
		background: transparent;
		border: 1px solid var(--adminInputBorder);
		color: var(--adminColorMain);
		cursor: pointer;
		padding: 5px;
		margin: 5px;
		outline: none;
	}

	button:hover {
		background: var(--adminInputBg);
	}

	/* .link {
		color: var(--link);
		font-size: var(--fsS);
		cursor: pointer;
	}

	.link:hover {
		color: var(--linkHover);
	} */

	.inputContainer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: var(--adminInputBg);
		width: 100%;
		border: 1px solid var(--adminInputBorder);
		color: var(--adminColorMain);
		font-size: var(--fsS);
		height: clamp(25px, 2.5vw, 40px);
		margin-top: 10px;
		padding: 10px;
	}

	.inputContainer:focus-within {
		background-color: var(--adminInputFocus);
	}

	input {
		border: none;
		outline: none;
		padding: 0;
		margin: 0;
		color: var(--adminColorMain);
		font-size: var(--fsS);
		background-color: transparent;
	}

	input:focus {
		outline: none;
	}

	.eye {
		background-image: url('/images/icon_eye.png');
		background-size: cover;
		width: var(--icon);
		height: var(--icon);
		cursor: pointer;
		margin-right: 0.5%;
	}

	.buttonContainer {
		display: flex;
		justify-content: center;
		margin-top: 1.5%;
		width: 100%;
	}

	.error {
		font-size: var(--fsS);
		color: var(--colorError);
	}
</style>
